export default __webpack_public_path__ + "f7664bb07c0e2754c1fdec416438cfc3.png";